/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const ReorderVerticalLinesStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M15 7.49995C14.5029 7.49995 14.1 7.09701 14.1 6.59995C14.1 6.1029 14.5029 5.69995 15 5.69995C15.497 5.69995 15.9 6.1029 15.9 6.59995C15.9 7.09701 15.497 7.49995 15 7.49995Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 12.9C14.5029 12.9 14.1 12.497 14.1 12C14.1 11.5029 14.5029 11.1 15 11.1C15.497 11.1 15.9 11.5029 15.9 12C15.9 12.497 15.497 12.9 15 12.9Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1 17.3999C14.1 17.897 14.5029 18.2999 15 18.2999C15.497 18.2999 15.9 17.897 15.9 17.3999C15.9 16.9029 15.497 16.4999 15 16.4999C14.5029 16.4999 14.1 16.9029 14.1 17.3999Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99998 7.49995C8.50292 7.49995 8.09998 7.09701 8.09998 6.59995C8.09998 6.10289 8.50292 5.69995 8.99998 5.69995C9.49703 5.69995 9.89998 6.10289 9.89998 6.59995C9.89998 7.09701 9.49703 7.49995 8.99998 7.49995Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99998 12.9C8.50292 12.9 8.09998 12.497 8.09998 12C8.09998 11.5029 8.50292 11.1 8.99998 11.1C9.49703 11.1 9.89998 11.5029 9.89998 12C9.89998 12.497 9.49703 12.9 8.99998 12.9Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.09998 17.3999C8.09998 17.897 8.50292 18.2999 8.99998 18.2999C9.49703 18.2999 9.89998 17.897 9.89998 17.3999C9.89998 16.9029 9.49703 16.4999 8.99998 16.4999C8.50292 16.4999 8.09998 16.9029 8.09998 17.3999Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { ReorderVerticalLinesStrokeIcon };
